export const COPY_ITEM = 'COPY_GENERIC_ITEM';



// WEBPACK FOOTER //
// ./src/app/stores/copy-paste/copy-paste-constants.js